import { render, staticRenderFns } from "./ManagementReject.vue?vue&type=template&id=6c76e183"
import script from "./ManagementReject.vue?vue&type=script&lang=js"
export * from "./ManagementReject.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports